import endpoints from './endpoints'
import request from '../../request'

export function listBooks(projectId) {
  return request({
    url: endpoints.books,
    method: 'get',
    params: { project_id: projectId },
  })
}

export function listAdminBooks(projectId) {
  return request({
    url: endpoints.adminBooks,
    method: 'get',
    params: { project_id: projectId },
  })
}

export function saveBook(data, bookId = null) {
  return request({
    url: bookId ? endpoints.book(bookId) : endpoints.books,
    method: bookId ? 'patch' : 'post',
    data,
  })
}

export function deleteBook(bookId) {
  return request({
    url: endpoints.book(bookId),
    method: 'delete',
  })
}

export function listBookCodes(projectId) {
  return request({
    url: endpoints.codes,
    method: 'get',
    params: { project_id: projectId },
  })
}

export function saveBookCode(data, codeId = null) {
  return request({
    url: codeId ? endpoints.code(codeId) : endpoints.codes,
    method: codeId ? 'patch' : 'post',
    data,
  })
}

export function setBookCodeAssignment(codeId, data) {
  return request({
    url: endpoints.codeAssignment(codeId),
    method: 'put',
    data,
  })
}

export function listAllFolios(projectId, params = {}) {
  return request({
    url: endpoints.allFolios,
    method: 'get',
    params: Object.assign({ project_id: projectId }, params),
  })
}

export function listFolios(bookId, params = {}) {
  return request({
    url: endpoints.folios(bookId),
    method: 'get',
    params,
  })
}

export function createFolio(bookId, data, onUploadProgress = null) {
  return request({
    url: endpoints.folios(bookId),
    method: 'post',
    data,
    onUploadProgress,
  })
}

export function createOpeningFolio(bookId, data, onUploadProgress = null) {
  return request({
    url: endpoints.folioOpening(bookId),
    method: 'post',
    data,
    onUploadProgress,
  })
}

export function publishFolioFromDraft(bookId, data, onUploadProgress = null) {
  return request({
    url: endpoints.folioFromDraft(bookId),
    method: 'post',
    data,
    onUploadProgress,
  })
}

export function getFolio(folioId) {
  return request({
    url: endpoints.folio(folioId),
    method: 'get',
  })
}

export function getFolioPdf(folioId) {
  return request({
    url: endpoints.pdf(folioId),
    method: 'get',
  })
}

export function updateFolioVisibility(folioId, visibility) {
  return request({
    url: endpoints.visibility(folioId),
    method: 'patch',
    data: { visibility },
  })
}

export function updateFolioMetadata(folioId, data) {
  return request({
    url: endpoints.metadata(folioId),
    method: 'patch',
    data,
  })
}

export function updateFolioDescription(folioId, description, idempotencyKey = null) {
  const config = {
    url: endpoints.description(folioId),
    method: 'patch',
    data: { description },
  }
  if (idempotencyKey) config.headers = { 'Idempotency-Key': idempotencyKey }
  return request(config)
}

export function acknowledgeFolio(folioId, idempotencyKey = null) {
  const config = {
    url: endpoints.acknowledgement(folioId),
    method: 'post',
  }
  if (idempotencyKey) config.headers = { 'Idempotency-Key': idempotencyKey }
  return request(config)
}

export function getFolioAcknowledgements(folioId) {
  return request({
    url: endpoints.acknowledgements(folioId),
    method: 'get',
  })
}

export function addFolioInteraction(folioId, data, idempotencyKey = null) {
  const config = {
    url: endpoints.interactions(folioId),
    method: 'post',
    data,
  }
  if (idempotencyKey) config.headers = { 'Idempotency-Key': idempotencyKey }
  return request(config)
}

export function finishFolio(folioId) {
  return request({
    url: endpoints.finish(folioId),
    method: 'post',
  })
}
